export default {
	"Save Path":"Save Path",
}
